var CookieManager = /** @class */ (function () {
    function CookieManager() {
    }
    CookieManager.prototype.set = function (name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = "".concat(name, "=").concat(value).concat(expires, "; path=/");
    };
    CookieManager.prototype.get = function (name) {
        var regex = new RegExp("(^| )" + name + "=([^;]+)");
        var match = regex.exec(document.cookie);
        return match ? decodeURIComponent(match[2]) : null;
    };
    CookieManager.prototype.delete = function (name) {
        document.cookie = "".concat(name, "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 UTC;");
    };
    return CookieManager;
}());
export { CookieManager };
